import { Capacitor } from "@capacitor/core";
import { useHistory } from "react-router";
import { PushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { getCurrentUser, updateDevicePushId } from "../firebase/firebase";
import { useIonToast } from "@ionic/react";
import { useEffect } from "react";

const PushNotification: React.FC = () => {
    const history = useHistory();
    const [presentToast] = useIonToast();

    useEffect(() => {
        registerPushNotification();
      }, []);

    const registerPushNotification = () => {
        if (Capacitor.isNativePlatform()) {
            PushNotifications.checkPermissions().then((res) => {
              if (res.receive !== 'granted') {
                PushNotifications.requestPermissions().then((res) => {
                  if (res.receive === 'denied') {
                    showToast('Push Notification permission denied');
                  }
                  else {
                    //showToast('Push Notification permission granted');
                    register();
                  }
                });
              }
              else {
                register();
              }
            });
          }
      }
    
      const register = () => {
    
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
    
        // On success, we should be able to receive notifications
        PushNotifications.addListener('registration',
          (token: Token) => {
           // showToast('Push registration success');
    
            updateDevicePushId(token.value);
          }
        );
    
        // Some issue with our setup and push will not work
        PushNotifications.addListener('registrationError',
          (error: any) => {
            alert('Error on registration: ' + JSON.stringify(error));
          }
        );
    
        // Show us the notification payload if the app is open on our device
        PushNotifications.addListener('pushNotificationReceived',
          (notification: PushNotificationSchema) => {
            //jak jestem w aplikacji to nic nie robię
          }
        );
    
        // Method called when tapping on a notification
        PushNotifications.addListener('pushNotificationActionPerformed',
          (action: ActionPerformed) => {
            //console.log("pushNotificationActionPerformed", action.notification)
            if (action.notification.data.type === "newMessage" && getCurrentUser().smsPanel) {
              history.push("/app/smses")
            }
          }
        );
      }
    
      const showToast = async (msg: string) => {
        presentToast({
          message: msg,
          duration: 3000,
          position: 'top'
        });
      }

      return <div></div>;
}

export default PushNotification;